var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPrimaryBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_862",
    "data-name": "Group 862",
    xmlns: "http://www.w3.org/2000/svg",
    width: 233.219,
    height: 54,
    viewBox: "0 0 233.219 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(54.791 19.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M92.783,48.669h9.095a8.552,8.552,0,0,1,5.492,1.487q1.819,1.486,1.819,4.74a6.943,6.943,0,0,1-.681,3.358,5.273,5.273,0,0,1-2.152,2.029q3.428,1.33,3.429,5.561,0,6.788-7.626,6.787H92.783Zm8.885,3.358h-5v6.856h5.142q3.428,0,3.428-3.533Q105.235,52.027,101.668,52.027Zm.21,10.144H96.666v7.1h5.281a4.417,4.417,0,0,0,2.887-.8A3.433,3.433,0,0,0,105.8,65.7a3.124,3.124,0,0,0-1.119-2.745A4.749,4.749,0,0,0,101.878,62.171Z",
    transform: "translate(-92.783 -48.039)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M129.276,70.416l.98-.1.07,2.833a36.2,36.2,0,0,1-7.065.8q-3.883,0-5.58-2.133t-1.7-6.821q0-9.3,7.591-9.305,7.347,0,7.346,8.011l-.244,2.728H119.832a4.789,4.789,0,0,0,.945,3.183q.909,1.014,3.393,1.014T129.276,70.416Zm-2.1-6.926a5.971,5.971,0,0,0-.822-3.62,3.358,3.358,0,0,0-2.781-1.032,3.482,3.482,0,0,0-2.85,1.085,5.771,5.771,0,0,0-.927,3.568Z",
    transform: "translate(-95.871 -48.973)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M135.271,56.134h3.743l3.708,14.236h.945l3.707-14.236h3.779l-6.647,25.009h-3.743l2.1-7.52h-3.007Z",
    transform: "translate(-98.438 -49.032)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M157.449,57.964q1.8-2.274,6-2.275t6,2.275q1.8,2.274,1.8,6.821T169.5,71.641q-1.749,2.308-6.051,2.308T157.4,71.641q-1.749-2.309-1.749-6.856T157.449,57.964ZM160.3,69.332q.8,1.4,3.148,1.4t3.148-1.4a9.677,9.677,0,0,0,.8-4.582,8.748,8.748,0,0,0-.856-4.512,4.268,4.268,0,0,0-6.191,0,8.737,8.737,0,0,0-.857,4.512A9.675,9.675,0,0,0,160.3,69.332Z",
    transform: "translate(-101.15 -48.973)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M181.815,73.565H178V56.075h3.777v1.085a9.739,9.739,0,0,1,4.828-1.47q3.5,0,4.775,1.977t1.276,6.523v9.375h-3.777v-9.27a9.508,9.508,0,0,0-.612-4.022,2.542,2.542,0,0,0-2.5-1.189,8.672,8.672,0,0,0-3.429.7l-.525.21Z",
    transform: "translate(-104.125 -48.973)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M207.282,50.322q-5.247,0-5.247,3.952a3.4,3.4,0,0,0,1.208,3.026,16.068,16.068,0,0,0,4.9,1.645,12.433,12.433,0,0,1,5.229,2.133q1.54,1.312,1.54,4.32,0,7.451-7.73,7.451a43.25,43.25,0,0,1-6.4-.6l-1.26-.174.28-2.238a59.871,59.871,0,0,0,7.241.629q5.176,0,5.176-4.863a3.3,3.3,0,0,0-1.137-2.816,11.057,11.057,0,0,0-4.251-1.452,14.309,14.309,0,0,1-5.806-2.256q-1.714-1.382-1.714-4.634,0-6.507,7.8-6.507a43.081,43.081,0,0,1,6.121.525l1.189.175-.245,2.273A65.669,65.669,0,0,0,207.282,50.322Z",
    transform: "translate(-106.96 -47.942)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M233.918,71.4l1.014-.1.07,2.063a50.265,50.265,0,0,1-6.821.56q-3.778,0-5.352-2.186t-1.573-6.8q0-9.2,7.31-9.2a6.687,6.687,0,0,1,5.282,1.977q1.749,1.977,1.749,6.209l-.14,1.994H223.914a7.171,7.171,0,0,0,1.05,4.3,4.288,4.288,0,0,0,3.655,1.4Q231.225,71.611,233.918,71.4Zm-.945-7.591q0-3.218-1.031-4.547a3.989,3.989,0,0,0-3.358-1.33,4.3,4.3,0,0,0-3.5,1.4,7.058,7.058,0,0,0-1.207,4.477Z",
    transform: "translate(-109.882 -48.979)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M245.143,73.57H242.52V56.08h2.588V57.3a11.193,11.193,0,0,1,5.422-1.574q3.5,0,4.7,1.889t1.206,6.716V73.57h-2.588V64.405a11.837,11.837,0,0,0-.717-4.985q-.718-1.346-3.061-1.346a9.148,9.148,0,0,0-2.361.332,11.809,11.809,0,0,0-1.906.647l-.665.316Z",
    transform: "translate(-112.712 -48.979)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M269.534,58.074q-3.813,0-3.813,2.658a1.836,1.836,0,0,0,.875,1.732,14.834,14.834,0,0,0,3.987,1.049,10.63,10.63,0,0,1,4.407,1.521q1.3.98,1.3,3.673a4.561,4.561,0,0,1-1.731,3.953,8.539,8.539,0,0,1-5.055,1.259,31.692,31.692,0,0,1-5.107-.49l-1.049-.175.14-2.274a44.512,44.512,0,0,0,6.016.6,6.022,6.022,0,0,0,3.1-.648,2.333,2.333,0,0,0,1.066-2.168,2.2,2.2,0,0,0-.909-2.064,13.459,13.459,0,0,0-3.987-1.032,10.526,10.526,0,0,1-4.373-1.434q-1.294-.944-1.294-3.5a4.248,4.248,0,0,1,1.8-3.777,7.814,7.814,0,0,1,4.495-1.225,36.851,36.851,0,0,1,5.351.49l.98.175-.07,2.238A45.557,45.557,0,0,0,269.534,58.074Z",
    transform: "translate(-115.451 -48.979)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M294.724,71.4l1.014-.1.07,2.063a50.277,50.277,0,0,1-6.821.56q-3.778,0-5.352-2.186t-1.573-6.8q0-9.2,7.31-9.2a6.687,6.687,0,0,1,5.282,1.977q1.749,1.977,1.749,6.209l-.14,1.994H284.72a7.166,7.166,0,0,0,1.05,4.3,4.289,4.289,0,0,0,3.655,1.4Q292.031,71.611,294.724,71.4Zm-.945-7.591q0-3.218-1.031-4.547a3.989,3.989,0,0,0-3.358-1.33,4.307,4.307,0,0,0-3.5,1.4,7.058,7.058,0,0,0-1.206,4.477Z",
    transform: "translate(-117.975 -48.979)",
    fill: "#231f20"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M46.425,46.992l0,.153.088-.029Z",
    transform: "translate(-31.822 -28.435)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M62.916,45.955",
    transform: "translate(-34.017 -28.297)",
    fill: "#35a7cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M52.934,74.892,44.4,73.082l1.3,12.3c.348.084.7.161,1.056.225a18.486,18.486,0,0,0,18.755-8.054Z",
    transform: "translate(-31.552 -31.907)",
    fill: "#0e7e99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M69.838,64.179a18.4,18.4,0,0,0-4.391-11.416L58.6,64.628l-4.36,7.559,12.574,2.666q.212-.322.411-.656A18.387,18.387,0,0,0,69.838,64.179Z",
    transform: "translate(-32.863 -29.203)",
    fill: "#155f70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M40.277,44.34V33.077l-10.7-7.491V60.981h0c0,.22,0,.442.007.664.017.566.063,1.124.129,1.676l11.767-5.246,7.969-3.553Z",
    transform: "translate(-29.58 -25.586)",
    fill: "#00beeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M63.645,51.564a18.49,18.49,0,0,0-21.7-4.6l9.179,10.184,5.843,6.482L63.81,51.762C63.754,51.7,63.7,51.629,63.645,51.564Z",
    transform: "translate(-31.226 -28.203)",
    fill: "#1c3f49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M42.451,71.75l-.916-8.678L29.768,68.318c.031.257.068.513.11.767A18.489,18.489,0,0,0,43.75,84.054Z",
    transform: "translate(-29.605 -30.575)",
    fill: "#079ec0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPrimaryBlack);
export default __webpack_public_path__ + "static/media/logo-primary-black.2ee9c8ed.svg";
export { ForwardRef as ReactComponent };